import { render, staticRenderFns } from "./EditDialog.vue?vue&type=template&id=317f9638&scoped=true"
import script from "@/views/Variants/EditDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Variants/EditDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Variants/edit-dialog.scss?vue&type=style&index=0&id=317f9638&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317f9638",
  null
  
)

export default component.exports